<script setup lang="ts">
import { RouterView } from 'vue-router'
</script>

<template>
  <RouterView v-slot="{ Component }">
    <transition name="route" mode="out-in">
      <component :is="Component" />
    </transition>
  </RouterView>
</template>

<style>
/* 路由转场动画 */
.route-enter-active,
.route-leave-active {
  transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}

.route-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.route-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
